import React, { ReactNode } from 'react';

import {
  LoadTournament,
  Photo,
  LogoTB,
  Wrap,
} from './styled';

interface Props {
  children: ReactNode;
}

const TournamentLoad = ({ children }: Props) => {
  return (
    <LoadTournament>
      <Photo>
        <LogoTB />
      </Photo>
      <Wrap>
        <>{children}</>
      </Wrap>
    </LoadTournament>
  );
};

export default TournamentLoad;
